export default {
      id: "common__copy_sm-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__copy_sm",
      toString: function () {
        return this.url;
      }
    }